import React, { useState } from 'react';
import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
import { auth } from '../utils/firebase';
import { ToastContainer, toast } from 'react-toastify';
import { getAuthErrorMessage, checkEmpty } from "../utils/Helper";

/**
 * ChangePasswordButton
 * A drop-in component that toggles between a sleek button and 
 * a glassmorphism password update form with Re-authentication.
 */
const ChangePasswordButton = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

      const { theme = 'dark' } = props;
    const isDark = theme === 'dark';

 

    const handleUpdatePassword = async (e) => {
        e.preventDefault();

        // 1. Validation
        if (checkEmpty(currentPassword) || checkEmpty(newPassword) || checkEmpty(confirmPassword)) {
            toast.error("Please fill in all fields.");
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error("New passwords do not match.");
            return;
        }

        if (newPassword.length < 6) {
            toast.error("New password must be at least 6 characters.");
            return;
        }

        setLoading(true);
        const user = auth.currentUser;

        try {
            // 2. Re-authenticate (Required by Firebase for sensitive ops)
            const credential = EmailAuthProvider.credential(user.email, currentPassword);
            await reauthenticateWithCredential(user, credential);

            // 3. Update Password
            await updatePassword(user, newPassword);
            
            toast.success("Password updated successfully!");
            
            // Wait briefly so user sees success message before closing
            setTimeout(() => {
                resetForm();
            }, 2000);

        } catch (error) {
            toast.error(getAuthErrorMessage(error.code));
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setIsOpen(false);
    };

    // Initial Button State
    if (!isOpen) {
        return (
            <div className="change-password-wrapper">
                <button 
                    className="btn-glass-create" 
                    onClick={() => setIsOpen(true)}
                    style={{ padding: '8px 25px', cursor: 'pointer' }}
                >
                    Change Password
                </button>
            </div>
        );
    }

    // Expanded Form State
    return (
        <div className="auth-card glass-modal-content animate-fade-in" style={{ marginTop: '20px'}}>
            <h3 className="auth-title" style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
                Update Security
            </h3>
            
            <form onSubmit={handleUpdatePassword}>
                <div className="auth-form-group">
                    <label className="meta-label gold-accent">Current Password</label>
                    <input
                        type="password"
                        className={isDark ? "glass-input" : "form-control"}
                        placeholder="Current password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                    />
                </div>

                <div className="auth-form-group">
                    <label className="meta-label teal-accent">New Password</label>
                    <input
                        type="password"
                       className={isDark ? "glass-input" : "form-control"}
                        placeholder="New password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                </div>

                <div className="auth-form-group">
                    <label className="meta-label teal-accent">Confirm New Password</label>
                    <input
                        type="password"
                          className={isDark ? "glass-input" : "form-control"}
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>

                <div className="d-flex gap-2" style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-glass-save-edit"
                        style={{ flex: 2, padding: '10px' }}
                    >
                        {loading ? "Verifying..." : "Save Changes"}
                    </button>
                    
                    <button
                        type="button"
                        className="btn-sort-pill orange"
                        onClick={resetForm}
                        style={{ flex: 1, height: 'auto', fontSize: '11px' }}
                    >
                        Cancel
                    </button>
                </div>
            </form>

            <ToastContainer 
                position="bottom-center" 
                autoClose={4000} 
                theme="dark" 
                pauseOnHover
            />
        </div>
    );
};

export default ChangePasswordButton;